//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../general/exceptions-service';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../general/http-client-service';
import { Injectable } from '@angular/core';
import { InviewUserCliDTO } from 'src/app/core/models/inview/inview-user-cli.dto';

@Injectable({ providedIn: 'root' })

export class InviewUsersClisService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public cliExistsOnDifferentUser(inviewUserId: number, cli: string): Observable<InviewUserCliDTO> {
    try {
      return forkJoin({
               cliEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(cli),
               inviewUserIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewUserId, true)
             })
             .pipe(
               switchMap(({ cliEncResult, inviewUserIdEncResult }) => {
                 const cliEnc           =cliEncResult.result;
                 const inviewUserIdEncSS=inviewUserIdEncResult.result;
                 
                 return this.httpClientService.get<InviewUserCliDTO>(environment.eSimApi +
                                                                     eSimApiPaths.InviewUsersClis + "/" +
                                                                     eSimApiPaths.InviewUsersClisCliExistsOnDifferentUser +
                                                                     "?inviewUserIdEncSS=" + inviewUserIdEncSS +
                                                                     "&cliEnc=" + cliEnc);
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
